import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { setupRoutes } from '@/router/setuproute.js'

Vue.use(VueRouter)


// 初始路由，只包含登录页面
const constantRoutes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/Login.vue')
    }
]

const router = new VueRouter({
    routes: constantRoutes
})

router.beforeEach((to, from, next) => {
    console.log(to)
    const token = store.state.token;
    if (to.path === '/login') {
        next();
        return;
    }

    if (!token) {
        next('/login');
        return;
    }

    const isRouteExists = router.getRoutes().some(route => route.path === to.path);
    if (isRouteExists) {
        next();
        return;
    }
    const routes = store.state.routes;
    try {
        // 确保路由配置已加载
        if (!routes) {
            next('/login')
        }


        const userRoutes = setupRoutes(routes);
        if (!userRoutes) throw new Error('No valid routes');

        // 动态添加路由到 home 下
        router.addRoute('home', {
            path: '/',
            name: 'home',
            component: () => import('@/views/layout/Layout.vue'),
            children: userRoutes
        });

        // 重新导航到目标路径
        if (to.path) {
            next({ path: to.path, replace: true });
        } else {
            next();
        }
    } catch (error) {
        next('/login');
    }
});


export default router
